goog.provide("shadow.js.shim.module$src$svg$type$tasks$roadmap_svg$default");
shadow.js.shim.module$src$svg$type$tasks$roadmap_svg$default = shadow.js.shim.module$src$svg$type$tasks$roadmap_svg.default;
